import React from "react";
import { useLanguage } from "../Translations/LenguageContext";

const DepLearn = () => {
    const { t } = useLanguage();

    return (
        <div className="brain_cont fade-in">
            <h3>{t.incrementalLearning.title}</h3>
            <p className="brain_card_desc">{t.incrementalLearning.desc}</p>
        </div>
    );
}

export default DepLearn;
